import React from 'react'
import paperBg from './backgrounds/paper.jpg'
import mailBg from './backgrounds/mail.jpg'
import lightsBg from './backgrounds/lights.jpg'
import notebookBg from './backgrounds/notebook.jpg'
import windowBg from './backgrounds/window.jpg'

const svgProps = {
    viewBox: '0 0 320 136',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    preserveAspectRatio: 'xMidYMid slice',
    'aria-hidden': true,
    focusable: 'false'
}

export default function ChoiceIllustration({ variant }) {
    if (variant === 'existing') return <ExistingArt />
    if (variant === 'generate') return <GenerateArt />
    if (variant === 'formTemplate') return <FormTemplateArt />
    if (variant === 'formAi') return <FormAiArt />
    return <ScratchArt />
}

function PhotoBg({ src, id }) {
    return (
        <>
            <defs>
                <filter id={id} x='-40' y='-40' width='400' height='220' filterUnits='userSpaceOnUse'>
                    <feGaussianBlur stdDeviation='3' />
                </filter>
            </defs>
            <g filter={`url(#${id})`}>
                <image
                    href={src}
                    xlinkHref={src}
                    x='-20'
                    y='-20'
                    width='360'
                    height='176'
                    preserveAspectRatio='xMidYMid slice'
                />
            </g>
            <rect width='320' height='136' fill='#FFFFFF' opacity='0.34' />
        </>
    )
}

function ScratchArt() {
    return (
        <svg {...svgProps}>
            <PhotoBg src={paperBg} id='paperBlur' />
            <rect x='78' y='24' width='164' height='100' rx='12' fill='#3F3A36' opacity='0.12' />
            <rect x='72' y='18' width='164' height='100' rx='12' fill='#FFFFFF' />
            <circle cx='90' cy='34' r='3.5' fill='#C7C0F2' />
            <circle cx='102' cy='34' r='3.5' fill='#DAD8FE' />
            <circle cx='114' cy='34' r='3.5' fill='#EEEFF2' />
            <rect x='90' y='50' width='78' height='8' rx='4' fill='#463DFB' />
            <rect x='90' y='68' width='124' height='5' rx='2.5' fill='#E1E1E0' />
            <rect x='90' y='80' width='104' height='5' rx='2.5' fill='#EEEEED' />
            <rect x='90' y='92' width='52' height='5' rx='2.5' fill='#EEEEED' />
            <rect x='146' y='90' width='2' height='10' rx='1' fill='#463DFB' />
            <g transform='translate(214 30) rotate(16)'>
                <rect width='18' height='62' rx='3' fill='#F2C252' />
                <rect width='18' height='12' rx='3' fill='#F96E4E' />
                <rect y='12' width='18' height='4' fill='#E7E3F6' />
                <path d='M0 62h18l-9 16z' fill='#F6D7B0' />
                <path d='M6 70h6l-3 10z' fill='#323232' />
            </g>
        </svg>
    )
}

function ExistingArt() {
    return (
        <svg {...svgProps}>
            <PhotoBg src={mailBg} id='mailBlur' />
            <rect x='30' y='28' width='100' height='88' rx='10' fill='#3F3A36' opacity='0.12' />
            <rect x='24' y='22' width='100' height='88' rx='10' fill='#FFFFFF' />
            <rect x='38' y='38' width='52' height='7' rx='3.5' fill='#2092BA' />
            <rect x='38' y='54' width='72' height='4' rx='2' fill='#C5D6DE' />
            <rect x='38' y='64' width='64' height='4' rx='2' fill='#D5E2E8' />
            <rect x='38' y='74' width='72' height='4' rx='2' fill='#D5E2E8' />
            <rect x='38' y='84' width='48' height='4' rx='2' fill='#E4ECEF' />
            <rect x='38' y='94' width='58' height='4' rx='2' fill='#E4ECEF' />
            <path d='M136 66h18' stroke='#2092BA' strokeWidth='2.5' strokeLinecap='round' />
            <path d='M148 59l9 7-9 7' stroke='#2092BA' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
            <rect x='184' y='24' width='112' height='96' rx='10' fill='#3F3A36' opacity='0.12' />
            <rect x='178' y='18' width='112' height='96' rx='10' fill='#FFFFFF' />
            <g clipPath='url(#existingPhoto)'>
                <rect x='190' y='30' width='88' height='30' fill='#8FD4EA' />
                <circle cx='210' cy='40' r='5' fill='#FFFFFF' />
                <path d='M190 60l20-14 16 8 18-12 34 18v6H190z' fill='#2092BA' />
            </g>
            <rect x='190' y='68' width='40' height='34' rx='6' fill='#E7F6FA' />
            <rect x='238' y='68' width='40' height='34' rx='6' fill='#E7F6FA' />
            <rect x='196' y='76' width='28' height='3' rx='1.5' fill='#7ACEE6' />
            <rect x='196' y='84' width='20' height='3' rx='1.5' fill='#B0E3F1' />
            <rect x='244' y='76' width='28' height='3' rx='1.5' fill='#7ACEE6' />
            <rect x='244' y='84' width='18' height='3' rx='1.5' fill='#B0E3F1' />
            <defs>
                <clipPath id='existingPhoto'>
                    <rect x='190' y='30' width='88' height='30' rx='6' />
                </clipPath>
            </defs>
        </svg>
    )
}

function GenerateArt() {
    return (
        <svg {...svgProps}>
            <PhotoBg src={lightsBg} id='lightsBlur' />
            <Sparkle x='36' y='22' scale='1.15' color='#8669DC' />
            <Sparkle x='58' y='78' scale='0.7' color='#AB9CE9' />
            <Sparkle x='268' y='78' scale='0.85' color='#8669DC' />
            <rect x='92' y='26' width='148' height='96' rx='12' fill='#3F3A36' opacity='0.12' />
            <rect x='86' y='20' width='148' height='96' rx='12' fill='#FFFFFF' />
            <g clipPath='url(#generatePhoto)'>
                <rect x='100' y='34' width='120' height='26' fill='#C7C0F2' />
                <circle cx='124' cy='44' r='5' fill='#FFFFFF' />
                <path d='M100 60l28-14 22 8 26-12 44 18v6H100z' fill='#8669DC' />
            </g>
            <rect x='100' y='68' width='86' height='5' rx='2.5' fill='#E1E1E0' />
            <rect x='100' y='78' width='104' height='5' rx='2.5' fill='#EEEEED' />
            <rect x='100' y='94' width='52' height='12' rx='6' fill='#463DFB' />
            <defs>
                <clipPath id='generatePhoto'>
                    <rect x='100' y='34' width='120' height='26' rx='6' />
                </clipPath>
            </defs>
        </svg>
    )
}

function Sparkle({ x, y, scale = 1, color }) {
    return (
        <path
            transform={`translate(${x} ${y}) scale(${scale})`}
            d='M10 0c.7 4.6 2.4 7 7.4 8.4C12.4 9.6 10.7 12 10 16.6 9.3 12 7.6 9.6 2.6 8.4 7.6 7 9.3 4.6 10 0z'
            fill={color}
        />
    )
}

function FormTemplateArt() {
    return (
        <svg {...svgProps}>
            <PhotoBg src={notebookBg} id='notebookBlur' />
            <rect x='24' y='36' width='68' height='68' rx='10' fill='#FFFFFF' opacity='0.72' />
            <rect x='34' y='48' width='48' height='10' rx='3' fill='#E7F6FA' stroke='#B0E3F1' />
            <rect x='34' y='64' width='48' height='10' rx='3' fill='#E7F6FA' stroke='#B0E3F1' />
            <rect x='34' y='82' width='28' height='10' rx='5' fill='#7ACEE6' />
            <rect x='228' y='36' width='68' height='68' rx='10' fill='#FFFFFF' opacity='0.72' />
            <rect x='238' y='48' width='36' height='4' rx='2' fill='#C5D6DE' />
            <rect x='238' y='56' width='48' height='8' rx='3' fill='#E7F6FA' stroke='#B0E3F1' />
            <rect x='238' y='70' width='28' height='4' rx='2' fill='#C5D6DE' />
            <rect x='238' y='78' width='48' height='8' rx='3' fill='#E7F6FA' stroke='#B0E3F1' />
            <rect x='238' y='90' width='24' height='8' rx='4' fill='#7ACEE6' />
            <rect x='114' y='22' width='104' height='100' rx='12' fill='#3F3A36' opacity='0.12' />
            <rect x='108' y='16' width='104' height='100' rx='12' fill='#FFFFFF' stroke='#2092BA' strokeWidth='1.5' />
            <rect x='122' y='30' width='48' height='6' rx='3' fill='#2092BA' />
            <rect x='122' y='44' width='32' height='4' rx='2' fill='#C5D6DE' />
            <rect x='122' y='52' width='76' height='14' rx='4' fill='#F4FBFD' stroke='#B0E3F1' />
            <rect x='122' y='72' width='24' height='4' rx='2' fill='#C5D6DE' />
            <rect x='122' y='80' width='76' height='14' rx='4' fill='#F4FBFD' stroke='#B0E3F1' />
            <rect x='122' y='100' width='44' height='10' rx='5' fill='#2092BA' />
        </svg>
    )
}

function FormAiArt() {
    return (
        <svg {...svgProps}>
            <PhotoBg src={windowBg} id='windowBlur' />
            <Sparkle x='34' y='20' scale='1.15' color='#8669DC' />
            <Sparkle x='56' y='78' scale='0.7' color='#AB9CE9' />
            <Sparkle x='270' y='78' scale='0.85' color='#8669DC' />
            <rect x='98' y='26' width='140' height='96' rx='12' fill='#3F3A36' opacity='0.12' />
            <rect x='92' y='20' width='140' height='96' rx='12' fill='#FFFFFF' />
            <rect x='108' y='34' width='40' height='4' rx='2' fill='#C7C0F2' />
            <rect x='108' y='42' width='108' height='16' rx='4' fill='#F7F5FF' stroke='#D9D2F6' />
            <rect x='108' y='66' width='28' height='4' rx='2' fill='#C7C0F2' />
            <rect x='108' y='74' width='108' height='16' rx='4' fill='#F7F5FF' stroke='#D9D2F6' />
            <rect x='108' y='98' width='52' height='12' rx='6' fill='#463DFB' />
        </svg>
    )
}
